// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import styles from './PrivacyButton.module.scss';

const Button = ({
  children,
  className,
  hasInitialFocus,
  focusId,
  onClick,
  onFocusSet,
  ttsText,
  ...rest
}) => {
  return (
    <Selectable
      onSelect={onClick}
      hasInitialFocus={hasInitialFocus}
      focusId={focusId}
      onFocusSet={onFocusSet}
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <button
          type="button"
          className={classNames(
            styles.button,
            className,
            hasFocus ? styles.focused : styles.unfocused,
          )}
          onClick={onClick}
          {...rest}
        >
          {children}
        </button>
      )}
    />
  );
};

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  hasInitialFocus: PropTypes.bool,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  onFocusSet: PropTypes.func,
  ttsText: PropTypes.string.isRequired,
};

Button.defaultProps = {
  className: null,
  hasInitialFocus: false,
  onClick: () => {},
  focusId: null,
  onFocusSet: () => {},
};

export default React.memo(Button);
